// Path: ./src/app/components/RenderDeleteButtonTable/index.tsx
import { IconButton } from "@mui/material";
import { TouchRippleActions } from "@mui/material/ButtonBase/TouchRipple";
import { GridRenderCellParams } from "@mui/x-data-grid";
import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";

export function RenderDeleteButton(
  props: GridRenderCellParams<any, Date> | any,
) {
  const { hasFocus } = props;
  const buttonElement = React.useRef<HTMLButtonElement | null>(null);
  const rippleRef = React.useRef<TouchRippleActions | null>(null);

  React.useLayoutEffect(() => {
    if (hasFocus) {
      const input = buttonElement.current?.querySelector("input");
      input?.focus();
    } else if (rippleRef.current) {
      rippleRef.current.stop({} as any);
    }
  }, [hasFocus]);

  return (
    <IconButton
      ref={buttonElement}
      touchRippleRef={rippleRef}
      tabIndex={hasFocus ? 0 : -1}
      onKeyDown={(event: React.KeyboardEvent) => {
        if (event.key === " ") {
          event.stopPropagation();
        }
      }}
      onClick={() => {
        /**
         * Click event handler for a delete button in a table row.
         * Executes the provided onClick callback with the corresponding row data, if available.
         */
        props?.onClick && props?.onClick(props?.row);
      }}
      data-testid="renderdeletebutton-test-id"
    >
      <DeleteIcon></DeleteIcon>
    </IconButton>
  );
}
